import { FC } from 'react';
import { DateRangePicker } from 'rsuite';
import './styles.scss';
import { DateRange } from 'rsuite/esm/DateRangePicker';

interface indexProps {
  placeholder: string;
  setSelectedRangeDate: (value: DateRange | null) => void;
 [x: string]: any;
}


const StyledDateRangeSelect: FC<indexProps> = ({
  placeholder,
  setSelectedRangeDate,
  ...rest
}) => {
  return (
    <DateRangePicker
      placeholder={placeholder}
      onChange={(value) => setSelectedRangeDate(value)}
      {...rest}
    />
  );
};

export default StyledDateRangeSelect;
